package com.example.readingnotes.presentation.admin

import com.example.readingnotes.domain.model.Post
import com.example.readingnotes.domain.model.PostImage

data class AdminPostEditorState(
    val titleInput: String = "",
    val contentInput: String = "",
    val imageUrlInput: String = "",
    val statusInput: String = "published",
    val isSubmitting: Boolean = false,
    val errorMessage: String? = null,
    val isSuccess: Boolean = false,
    // Edit mode
    val isEditMode: Boolean = false,
    val editingPostId: String? = null,
    val originalPost: Post? = null,
    val isLoading: Boolean = false,
    // Delete confirmation
    val showDeleteConfirmation: Boolean = false,
    val deletingPostId: String? = null,
    val isDeleting: Boolean = false,
    val deleteSuccess: Boolean = false,
    // TOTP
    val totpCodeInput: String = "",
    val totpRequired: Boolean = false,
    // Image management
    val images: List<PostImage> = emptyList(),
    val isUploadingImage: Boolean = false,
    val imageUploadError: String? = null,
    val tempImageUrl: String? = null,
    // Image editing
    val editingImage: PostImage? = null,
    val isEditingImage: Boolean = false,
    val imageEditError: String? = null,
)
